<template>
  <swiper-container
    ref = 'weekSliderSlide'>
      <week-slider-slide
        :start="monday"
        :end="saturday"
      />
  </swiper-container>
</template>
    
  <script>
    import WeekSliderSlide from './WeekSliderSlide.vue'
    import { useEventsStore } from '@/store/events'

    export default {
      name: 'WeekSlider',
      components: { WeekSliderSlide},
      computed: {
        monday() {
          let eventsStore = useEventsStore()
          return eventsStore.get_week_monday(eventsStore.selectedDate)
        },
        saturday() {
          let eventsStore = useEventsStore()
          return eventsStore.get_week_saturday(eventsStore.selectedDate)
        }
      },
      mounted() {}
    };
  
  </script>